









































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {Mixins} from 'vue-property-decorator';
import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
import {intersection} from 'lodash';
import {drawerNavigation, multiNil, nil} from '@/common';
import NavigationDrawerListItem from '@/components/Views/UI/NavigationDrawerListItem.vue';
import VendorMixin from '@/mixins/VendorMixin.vue';
import PasswordChangeDialog from '@/components/Views/Dashboard/PasswordChangeDialog.vue';

@Component({
    components: {
        PasswordChangeDialog,
        NavigationDrawerListItem,
    },
})
export default class NavigationDrawer extends Mixins(UserRoleMixin, VendorMixin) {
    @Prop({default: () => []})
    public navigation!: any[];
    @Prop({default: false})
    public show!: boolean;
    @Watch('show')
    public onShowChanged(value: boolean, oldValue: boolean) {
        this.open = value;
    }
    public open = false;
    public mini = false;
    public get permanent() {
        return this.isLG(true) && this.open;
    }
    public get temporary() {
        return this.isMD(false);
    }
    public get userDisplayName() {
        if (this.userIsVendor) {
            return `${this.user.vendorModel.firstName} ${this.user.vendorModel.lastName}`;
        } else {
            return this.user.email;
        }
    }
    public get drawerNavigationItems() {
        return drawerNavigation;
    }
    public get siteNavigationInDrawer() {
        return true;
    }
    public toggle() {
        if (!this.open) {
            this.open = true;
        } else {
            this.mini = false;
            this.open = false;
        }
    }
    public verifyUserRole(roles: string[]) {
        if (nil(roles)) {
            return true;
        }
        if (multiNil(this, 'user.roles', true)) {
            return false;
        }
        return intersection(roles, this.user.roles).length > 0;
    }
    public checkHideOnMini(hide) {
        if (hide && this.mini) { return false; }
        return true;
    }
    public logout() {
        this.$store.dispatch('auth/logout');
        this.$router.replace('/');
    }

}
